"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAppOnEnv = void 0;
// NODE_ENV is set to 'development' when application is run in dev mode (start command)
// and to 'production' when application is built (build command)
// so 'production' is set for application deployed to ANY env (DEV/QA/PROD in our case)
var isAppOnEnv = process.env.NODE_ENV !== 'development';
exports.isAppOnEnv = isAppOnEnv;